import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconMoveExit12 from './IconMoveExit12';
import IconMoveExit16 from './IconMoveExit16';
import IconMoveExit20 from './IconMoveExit20';
import IconMoveExit24 from './IconMoveExit24';
import IconMoveExit32 from './IconMoveExit32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconMoveExit = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconMoveExit12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconMoveExit16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconMoveExit20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconMoveExit24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconMoveExit32 {...props} />}
        </span>
    );
};
IconMoveExit.displayName = 'FondueIconMoveExit';

export default memo(IconMoveExit);
